import { firestore } from '@/firebaseConfig'
import BookingConfiguration from '../model/BookingConfiguration';

export default class BookingService {

    loadBookingConfigurationsForPublisher(publisherId) {
        return new Promise((resolve, reject) => {
            firestore.collection("publishers").doc(publisherId).collection("bookingConfigurations").doc("default").get().then((doc) => {
                if (doc.exists) {
                    resolve(new BookingConfiguration(doc.data()));
                } else {
                    // mguay: left there as a legacy code waiting for the app to be updated.
                    firestore.collection("publishers").doc(publisherId).collection("bookingConfigurations").doc("reservotron").get().then((doc) => {
                        if (doc.exists) {
                            resolve(new BookingConfiguration(doc.data()));
                        } else {
                            resolve(null);
                        }
                    }).catch((error) => {
                        reject(error);
                    });
                }
            }).catch((error) => {
                reject(error);
            });
        });
    }

    saveBookingConfigurationForPublisher(publisherId, bookingConfiguration) {
        if (!bookingConfiguration.id) {
            bookingConfiguration.id = "default";
        }

        console.log(bookingConfiguration.toJSON());

        // mguay: left there as a legacy code waiting for the app to be updated.
        firestore.collection("publishers").doc(publisherId).collection("bookingConfigurations").doc("reservotron").set(bookingConfiguration.toJSON());

        return firestore.collection("publishers").doc(publisherId).collection("bookingConfigurations").doc("default").set(bookingConfiguration.toJSON());
    }
}